import React, { useEffect, HtmlHTMLAttributes, useState } from "react";
import { connect } from "react-redux";
import { history } from "../../../../routers/AppRouter";
import { getAlertItems } from "../../../../actions/alert/alert-items";
import styled from 'styled-components';
import MainButton from "../../../../components/MainButton";
import moment from "moment";
import colors from '../../../../styles/colors';
import { getEmailStats } from "../../../../actions/portal/stats-email";
import { EmailStatsTypes, EMCStat } from "../stats-types";
import ABSmallButton from "../../../../components/ABSmallButton";
import { getEMCStats } from "../../../../actions/portal/emc-stat";

const PageWrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px;
`;

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TableStyle = styled.div`
  padding: 40px 0;
`;

const TableHeading = styled.div`
  display: flex;
`;

const TableRow = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  :hover {
    background: ${colors.gray100};
  }
`;

const TableCellHeading = styled.div`
  padding: 10px;
  width: 125px;
  font-weight: bold;
`;

const TableCell = styled.div`
  padding: 10px;
  width: 125px;
`;

const TableCellHeadingLarge = styled.div`
  padding: 10px;
  width: 300px;
  font-weight: bold;
`;

const TableCellLarge = styled.div`
  padding: 10px;
  width: 300px;
`;

const FilterContainer = styled.div`
  display: flex;
  margin: 20px 0 0 0;
`;

const Thumbnail = styled.div`
  img {
    width: 75px;
    height: 75px;
  }
`;

interface FilterButtonProps {
  activeFilterTitle?: boolean;
}

const FilterButton = styled.button <FilterButtonProps>`
  background: ${props => props.activeFilterTitle ? colors.blue : colors.white};
  color: ${props => props.activeFilterTitle ? colors.white : colors.black};
  padding: 10px 15px;
  cursor: pointer;
  border: none;
  border-right: 1px solid ${colors.lightGray};
  border-top: 1px solid ${colors.lightGray};
  border-bottom: 1px solid ${colors.lightGray};
  border-left: 1px solid ${colors.lightGray};

  &:nth-child(2), &:last-child {
    border-left: none;
  }
  :hover {
      background-color: ${props => props.activeFilterTitle ? '' : colors.gray100};
  }
`;

const StyledHeading = styled.div`
  padding: 10px 10px 10px 0;
  font-size: 40px;
`;

const EMCStats = (props: any) => {

  const [activeFilter, setActiveFilter] = useState('draft');

  useEffect(() => {
    props.getEMCStats();
  }, []);

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>, title: string) => {
    setActiveFilter(title);
    if (title === 'all') {
      props.getEMCStats();
    } else {
      // props.getEmailStats({ status: title });
    }
  }

  const createStateNavigate = () => {
    history.push('/portal/email-marketing/email-marketing-stats-form');
  }

  const handeDetailNavigate = (id: number) => {
    history.push({
      pathname: `/portal/email-marketing/${id}`,
    });
  }

  return (
    <>
      <PageWrapper>
        <HeadingContainer>
          <StyledHeading>Email Marketing Performance</StyledHeading>
          <MainButton onClick={createStateNavigate} title="Create EMC Stats" />
        </HeadingContainer>
        {/* <FilterContainer>
                    <FilterButton activeFilterTitle={activeFilter === 'draft'} onClick={(e) => handleButtonClick(e, 'draft')}>Draft</FilterButton>
                    <FilterButton activeFilterTitle={activeFilter === 'published'} onClick={(e) => handleButtonClick(e, 'published')}>Published</FilterButton>
                    <FilterButton activeFilterTitle={activeFilter === 'all'} onClick={(e) => handleButtonClick(e, 'all')}>All</FilterButton>
                </FilterContainer> */}
        <TableStyle>
          <TableHeading>
            <TableCellHeading>Image</TableCellHeading>
            <TableCellHeading>Id</TableCellHeading>
            <TableCellHeading>Client Id</TableCellHeading>
            <TableCellHeadingLarge>Subject</TableCellHeadingLarge>
            <TableCellHeading>Date</TableCellHeading>
            <TableCellHeading>Sent</TableCellHeading>
            <TableCellHeading>Delivered</TableCellHeading>
            {/* <TableCellHeading>Open Rate (%)</TableCellHeading> */}
            <TableCellHeading>Opens</TableCellHeading>
            <TableCellHeading>Clicks</TableCellHeading>
            <TableCellHeading>Link</TableCellHeading>
          </TableHeading>
          {
            (props.emcStats && props.emcStats.length > 0) &&
            props.emcStats.map((item: EMCStat) => {
              return (
                <TableRow key={item.id} onClick={() => handeDetailNavigate(item.id!)}>
                  <TableCell><Thumbnail><img src={`https://${item.imageUrl}`} alt="Add Image" /></Thumbnail></TableCell>
                  <TableCell>{item.id}</TableCell>
                  <TableCell>{item.clientId}</TableCell>
                  <TableCellLarge>{item.subject}</TableCellLarge>
                  {/* <TableCell>{item.issue}</TableCell> */}
                  {/* <TableCellLarge>{item.subject}</TableCellLarge> */}
                  <TableCell>{moment(item.date).format('MMM. Do, YYYY')}</TableCell>
                  {/* <TableCell><a href={item.link}>Link</a></TableCell> */}
                  <TableCell>{item.sent}</TableCell>
                  <TableCell>{item.delivered}</TableCell>
                  {/* <TableCell>{item.openRate}%</TableCell> */}
                  <TableCell>{item.opens}</TableCell>
                  <TableCell>{item.clicks}</TableCell>
                  <TableCell><a href={item.newsletterLink} target="_blank">Link</a></TableCell>
                  {/* <TableCell>{item.ctr}%</TableCell>
                                    <TableCell>{item.ctor}%</TableCell> */}
                  {/* <TableCell>{item.deliveryRate}%</TableCell> */}
                  {/* <TableCell>{item.bounceRate}%</TableCell>
                                    <TableCell>{item.unsubscribeRate}%</TableCell>
                                    <TableCell>{item.spamRate}%</TableCell>
                                    <TableCell>{item.growthRate !== undefined ? `${item.growthRate}%` : 'N/A'}</TableCell> */}
                  {/* <TableCell>{item.leads}</TableCell> */}
                </TableRow>
              );
            })
          }
        </TableStyle>
      </PageWrapper >
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    emcStats: state.emcStats.data
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  getEMCStats: (queryParams?: object) => dispatch(getEMCStats(queryParams))
});

export default connect(mapStateToProps, mapDispatchToProps)(EMCStats);